import { put } from 'redux-saga/effects';

import { ISubscriptionWellfunnel } from 'api/components/Subscriptions/types';

import { openModal } from 'store/modals/actions';
import { cancelSubscription, setCancellationCandidates } from 'store/subscriptions/actions';

import { ModalName } from 'modals/types';

import { getCancelSubscriptionErrorModalData } from 'helpers/subscriptions';

export function* callErrorCancellingBehaviour({
    errorCount,
    cancellationCandidates,
}: {
    errorCount: Record<string, string[]>;
    cancellationCandidates: ISubscriptionWellfunnel[];
}) {
    const subscriptionsCancellationFailedPartially = errorCount.current.length < cancellationCandidates.length;

    if (subscriptionsCancellationFailedPartially) {
        const candidate = cancellationCandidates.find((e) => e.external_id === errorCount.current[0]);

        yield put(setCancellationCandidates(candidate ? [candidate] : null));
    }

    yield put(
        openModal(ModalName.RetryErrorModal, {
            ...getCancelSubscriptionErrorModalData({
                isSingleError: errorCount.current.length > 1,
                subscriptionsCancellationFailedPartially,
            }),
            retryAction: () => cancelSubscription({ cancellationCandidates }),
        })
    );
}
